import { Tab, Tabs } from "@material-ui/core";

import * as React from "react";
import TeacherPortalGeneralStudentInformationTab from "./tabs/StudentGeneralInformationTab";
import TeacherPortalStudentLearningMaterialInformationTab from "./tabs/StudentLearningMaterialInformationTab";
import TeacherPortalStudentQuizResultsInformationTab from "./tabs/StudentQuizResultsInformationTab";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                children
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const TeacherPortalStudentTabPanel = ({ student, quizesOfStudent, activities, activitiesWithUsageData }) => {
    const [value, setValue] = React.useState(1);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return <div className="w-full">
        <div className="bg-white rounded shadow text-left">
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
            TabIndicatorProps={{className: "!bg-accentdark"}}>
                {/*Disabled for now because of not a lot of information
                 <Tab label="User Information" {...a11yProps(0)} /> */}
                <Tab value={1} label="Learning Material Usage" {...a11yProps(1)} />
                <Tab value={2} label="Quiz results" {...a11yProps(2)} />
            </Tabs>
            <h2 className="p-4 text-2xl">{student.user.firstname + " " + student.user.lastname}</h2>
            <div className="p-4">
                <TabPanel value={value} index={0}>
                    <TeacherPortalGeneralStudentInformationTab student={student} />
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <TeacherPortalStudentLearningMaterialInformationTab student={student} activities={activities} activitiesWithUsageData={activitiesWithUsageData} />
                </TabPanel>

                <TabPanel value={value} index={2}>
                    <TeacherPortalStudentQuizResultsInformationTab student={student} quizesOfStudent={quizesOfStudent} />
                </TabPanel>

            </div>
        </div>
    </div>
}


export default TeacherPortalStudentTabPanel